import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable()
export abstract class IThemeDirectiveProvider {
  public abstract getTheme(): Observable<number>;
}
